import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./theme/theme";

// Pages
import Home from "./pages/Home/Home";
import ProductCatalog from "./pages/ProductCatalog/ProductCatalog";
import ProductDetail from "./pages/ProductDetail/ProductDetail";
import Backoffice from "./pages/Backoffice/Backoffice";
import ContactPage from "./pages/Contact/ContactPage";
import Companies from "./pages/Companies/Companies";
import { QuotesPage } from "./pages";

// Layout
import Layout from "./components/layout/Layout";

// Components
import ScrollToTop from "./components/common/ScrollToTop";
import FloatingWhatsAppButton from "./components/common/FloatingWhatsAppButton";
import AnnouncementPopup from "./components/common/AnnouncementPopup";
import Favorites from "./pages/Favorites/Favorites";

// Componente wrapper para controlar el WhatsApp button
function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {/* Popup de anuncio - solo mostrar si NO estamos en rutas de admin */}
      {!isAdminRoute && <AnnouncementPopup />}
      {/* Solo mostrar WhatsApp button si NO estamos en rutas de admin */}
      {!isAdminRoute && <FloatingWhatsAppButton />}
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo" element={<ProductCatalog />} />
          <Route path="/producto/:slug" element={<ProductDetail />} />
          <Route path="/favoritos" element={<Favorites />} />
          <Route path="/cotizaciones" element={<QuotesPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          {/* <Route path="/empresas" element={<Companies />} /> */}
          <Route path="/admin" element={<Backoffice />} />
        </Routes>
      </Layout>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
